var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachementFilledIcon = function SvgAttachementFilledIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.03526,
    transform: "rotate(6.5 10 10)",
    fill: "#6F7D93",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3176 6.54073L13.0004 10.9186C13.5303 11.7834 13.3688 12.941 12.5587 13.5513C11.628 14.2525 10.3261 13.986 9.73275 13.0177L6.59866 7.90336C6.26649 7.3613 6.35376 6.63052 6.85879 6.24704C7.44152 5.80457 8.25963 5.96916 8.63237 6.57742L11.2948 10.9221C11.4343 11.1497 11.3622 11.4501 11.1346 11.5895C10.9069 11.729 10.6066 11.6569 10.4671 11.4294L8.24843 7.80874C8.14447 7.63909 7.91755 7.58463 7.74788 7.68861C7.5782 7.79259 7.52371 8.0195 7.62767 8.18915L9.81088 11.7518C10.1431 12.2939 10.8338 12.5479 11.4048 12.272C12.0636 11.9537 12.2883 11.15 11.9156 10.5417L9.29624 6.26736C8.76629 5.40255 7.66148 5.02092 6.74997 5.46566C5.70671 5.97407 5.34906 7.25758 5.9424 8.22584L9.05367 13.303C9.7814 14.4905 11.3021 15.0214 12.5542 14.4078C13.9918 13.6976 14.4807 11.9409 13.6642 10.6085L10.9384 6.16033C10.8344 5.99068 10.6075 5.93622 10.4378 6.04019C10.2682 6.14417 10.2137 6.37108 10.3176 6.54073Z",
    fill: "#6F7D93",
    stroke: "#6F7D93",
    strokeWidth: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachementFilledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "attachement-filled-icon.2fdf527e12c21c965c5daafe26e4b6a7.svg";